"use client"

import { FragmentType, graphql, useFragment } from "@/gql"
import React, { type JSX } from "react"
import { BusinessCardHeader } from "./BusinessCardHeader"
import { ImageSection } from "./ImageSection"
import Link from "next/link"
import { BreadCrumbRef, NovaSession } from "@/types"
import { createUrlWithBreadCrumb } from "@/utils/breadCrumbs"
import { ampli } from "@/ampli"

const ListBusinessCardFragment = graphql(`
  fragment ListBusinessCard on IndividualCreative {
    __typename
    id
    handle

    ...CreativeBusinessCardImagesSection
    ...BusinessCardHeader
  }
`)

interface Props {
  creative: FragmentType<typeof ListBusinessCardFragment> | undefined | null
  actionButtons?: JSX.Element
  serverSession: NovaSession
  breadCrumbRef?: BreadCrumbRef
  trackingEntryPoint: string
}

export const ListBusinessCard: React.FC<Props> = props => {
  const creative = useFragment(ListBusinessCardFragment, props.creative)
  const { serverSession, breadCrumbRef, trackingEntryPoint } = props

  const profileUrl = `/${creative?.handle}`
  const url = createUrlWithBreadCrumb({
    url: profileUrl,
    breadCrumbRef,
  })

  return (
    <div className="relative w-full">
      <BusinessCardHeader
        creative={creative}
        serverSession={serverSession}
        creativeUrl={url}
        trackingEntryPoint={trackingEntryPoint}
      />
      <Link
        href={url}
        onClick={() => {
          ampli.businessCardViewProfile({
            entry_point: trackingEntryPoint,
          })
        }}>
        <ImageSection
          creative={creative}
          type="list"
          showTextOverlay
          serverSession={serverSession}
          entryPoint={trackingEntryPoint}
        />
      </Link>
    </div>
  )
}
